import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
} from 'react-router-dom'
import Dashboard from '../pages/Dashboard/Dashboard'
import Script from '../pages/Script/Script'
import Profile from '../pages/Profile/Profile'
import Lead from '../pages/Lead/Lead'
import { SCENE_ROUTE } from '../shared/constants/global'

const CaseRouter = () => {
  return (
    <Router>
      <Switch>
        <Route path="/script" component={Script} />
        <Route path="/profile" component={Profile} />
        <Route path="/map/:mapId/poi/:poiId" component={Lead} />
        <Route path="/map" component={Dashboard} />
        <Route path={`/${SCENE_ROUTE}/:sceneId`} component={Lead} />
        <Redirect to="/map" />
      </Switch>
    </Router>
  )
}

export default CaseRouter
